var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MBUpload',{attrs:{"doc-type":_vm.docType},on:{"close":_vm.sendCloseMessage,"results":_vm.onScanResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }